import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

const Login: React.FC = () => {
  const { signInWithMagicLink } = useAuth();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const { error: signInError } = await signInWithMagicLink(email.trim());
    setSubmitting(false);
    if (signInError) {
      setError(signInError);
      return;
    }
    setSent(true);
  };

  return (
    <Container className="p-3 my-4" style={{ maxWidth: 480 }}>
      <Card className="info-panel">
        <Card.Body>
          <Card.Title>Sign in</Card.Title>
          <Card.Text className="mb-4">
            Enter your email address. If you have access, we'll send you a one-time
            login link.
          </Card.Text>

          {sent ? (
            <Alert variant="success">
              Check your inbox. The link will sign you in when you click it.
            </Alert>
          ) : (
            <Form onSubmit={handleSubmit}>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form.Floating className="mb-3">
                <Form.Control
                  id="login-email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
                <label htmlFor="login-email">Email address</label>
              </Form.Floating>
              <div className="d-flex justify-content-end">
                <Button type="submit" variant="primary" disabled={submitting || !email}>
                  {submitting ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" className="me-2" />
                      Sending...
                    </>
                  ) : (
                    'Send magic link'
                  )}
                </Button>
              </div>
            </Form>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Login;
